import React from 'react';
import Layout from '../components/Layout';




import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';

import EditingHeader from '../components/editingheader';
import EditingServices from '../components/editingservice';
import useScrollTransition from '../useScrollTransition';


const Editingpage = () => {
  useScrollTransition();
  return (
    <Layout>
      
        <EditingHeader/>
        <ScrollingText/>
        <EditingServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default Editingpage;